var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlinkPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.95004 8.54984L1.36769 7.59828C1.29649 7.572 1.23505 7.52452 1.19166 7.46225C1.14826 7.39998 1.125 7.3259 1.125 7.25C1.125 7.1741 1.14826 7.10002 1.19166 7.03775C1.23505 6.97548 1.29649 6.928 1.36769 6.90172L3.95004 5.95016L4.9016 3.36781C4.92788 3.29661 4.97536 3.23517 5.03763 3.19178C5.0999 3.14838 5.17398 3.12512 5.24988 3.12512C5.32578 3.12512 5.39986 3.14838 5.46213 3.19178C5.5244 3.23517 5.57188 3.29661 5.59816 3.36781L6.54972 5.95016L9.13207 6.90172C9.20327 6.928 9.26471 6.97548 9.3081 7.03775C9.3515 7.10002 9.37476 7.1741 9.37476 7.25C9.37476 7.3259 9.3515 7.39998 9.3081 7.46225C9.26471 7.52452 9.20327 7.572 9.13207 7.59828L6.54972 8.54984L5.59816 11.1322C5.57188 11.2034 5.5244 11.2648 5.46213 11.3082C5.39986 11.3516 5.32578 11.3749 5.24988 11.3749C5.17398 11.3749 5.0999 11.3516 5.03763 11.3082C4.97536 11.2648 4.92788 11.2034 4.9016 11.1322L3.95004 8.54984Z",
    stroke: "#42296E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.25V3.5",
    stroke: "#42296E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.875V5.375",
    stroke: "#42296E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 2.375H9.375",
    stroke: "#42296E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 4.625H11.25",
    stroke: "#42296E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlinkPurple);
export default __webpack_public_path__ + "static/media/blink_purple.4a1d2c0dce59b6bb3234b53662055acc.svg";
export { ForwardRef as ReactComponent };